import { API } from "./Config";

const STAFF_TOKEN_KEY = "mukbiStaffToken";

export function getStaffToken() {
  return localStorage.getItem(STAFF_TOKEN_KEY);
}

export function clearStaffSession() {
  localStorage.removeItem(STAFF_TOKEN_KEY);
  localStorage.removeItem("mukbiStaffName");
}

export async function staffApiFetch(endpoint, options = {}) {
  const token = getStaffToken();

  const headers = {
    ...(options.headers || {})
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (options.body && !(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  const response = await fetch(`${API}${endpoint}`, {
    ...options,
    headers
  });

  if (response.status === 401 && token) {
    if (getStaffToken() === token) {
      clearStaffSession();
    }
  }

  return response;
}
